//@ts-check
import { Delete, Title } from "@mui/icons-material";
import { SubTitle } from "../molecules/subtitle";
import { subscriptionStore } from "../../store/SubscriptionStore";
import React, { useState } from "react";
import { TransparentButton } from "../Button/TransparentButton";
import DeleteAccountDialog from "../../pages/OrderHistory/DeleteAccountDioalog";
import { Avatar } from "@mui/material";
import useUserDetailsStore from "../../store/UserStore";

export const AccountDetails = () => {
  const userDetails = useUserDetailsStore((state) => state.userDetail);
  const [showDeleteAccountDialog, setShowDeleteAccountDialog] = useState(false);

  const handleDeleteAccount = () => {
    setShowDeleteAccountDialog(true);
  };
  const Heading = ({ children }) => {
    return <h1 className="text-[1.5rem] font-bold text-center">{children}</h1>;
  };

  const Label = ({ children }) => {
    return <label className="text-lg font-bold">{children}</label>;
  };
  const SubLabel = ({ children }) => {
    return <p className="font-[500]">{children}</p>;
  };
  const Typography = ({ children }) => {
    return <p className=" text-sm md:text-lg">{children}</p>;
  };

  const shippingAddresses = userDetails?.user?.address?.shipping;
  const billingAddresses = userDetails?.user?.address?.billing;
  return (
    <div className="mt-8">
      <DeleteAccountDialog
        showDeleteDialog={showDeleteAccountDialog}
        onClose={() => setShowDeleteAccountDialog(false)}
      />
      <div className="grid grid-cols-10 gap-4">
        <div className="col-span-full lg:col-span-2 flex flex-col justify-center gap-4 items-center">
          <Avatar
            sx={{ width: 100, height: 100 }}
            sizes="large"
            alt={userDetails?.user?.name}
            src={
              userDetails?.user?.email_picture_url ||
              userDetails?.user?.profile_picture_url
            }
          />
          <div>
            <Heading>{userDetails?.user?.name}</Heading>
            <Typography>({userDetails?.user?.email})</Typography>
          </div>
        </div>
        <div className="col-span-full lg:col-span-8 border-[2px] border-[#3cc3aa] rounded-md p-4 bg-[#3cc3aa15]">
          <div className="flex justify-end ">
            <p
              onClick={handleDeleteAccount}
              className="flex text-red-500 font-bold hover:drop-shadow-xl hover:scale-110 duration-300 ease-in-out transition-all cursor-pointer"
            >
              <span className="hidden md:flex">Delete Account</span>
              <Delete />
            </p>
          </div>
          <Label>Shipping Address</Label>
          <hr className="my-3" />
          <div className="grid grid-cols-accountDetails gap-2">
            <div>
              <SubLabel>Recipient Name</SubLabel>
              <Label>
                {shippingAddresses?.recipient_name || "     -     "}
              </Label>
            </div>
            <div>
              <SubLabel>Country</SubLabel>
              <Label>{shippingAddresses?.country || "     -     "}</Label>
            </div>
            <div>
              <SubLabel>City</SubLabel>
              <Label>{shippingAddresses?.city || "     -     "}</Label>
            </div>
            <div>
              <SubLabel>PostCode</SubLabel>
              <Label>{shippingAddresses?.postcode || "     -     "}</Label>
            </div>{" "}
            <div>
              <SubLabel>State</SubLabel>
              <Label>{shippingAddresses?.state || "     -     "}</Label>
            </div>
            <div>
              <SubLabel>State Code</SubLabel>
              <Label>{shippingAddresses?.state_code || "     -     "}</Label>
            </div>
            <div>
              <SubLabel>Contact</SubLabel>
              <Label>{shippingAddresses?.phone || "     -     "}</Label>
            </div>
            <div>
              <SubLabel>Street 1</SubLabel>
              <Label>{shippingAddresses?.street1 || "     -     "}</Label>
            </div>{" "}
            <div>
              <SubLabel>Street 2</SubLabel>
              <Label>{shippingAddresses?.street2 || "     -     "}</Label>
            </div>
          </div>
          <br />
          {/* <Label>Billing Details</Label>
          <div className="grid grid-cols-accountDetails gap-2">
            <div>
              <Label>Recipient Name</Label>
              <p>{billingAddresses?.recipient_name}</p>
            </div>
            <div>
              <Label>Country</Label>
              <p>{billingAddresses?.country}</p>
            </div>
            <div>
              <Label>City</Label>
              <p>{billingAddresses?.city}</p>
            </div>
            <div>
              <Label>PostCode</Label>
              <p>{billingAddresses?.postcode}</p>
            </div>{" "}
            <div>
              <Label>State</Label>
              <p>{billingAddresses?.state}</p>
            </div>
            <div>
              <Label>State Code</Label>
              <p>{billingAddresses?.state_code || "     -     "}</p>
            </div>
            <div>
              <Label>Contact</Label>
              <p>{billingAddresses?.phone}</p>
            </div>
            <div>
              <Label>Street 1</Label>
              <p>{billingAddresses?.street1}</p>
            </div>{" "}
            <div>
              <Label>Street 2</Label>
              <p>{billingAddresses?.street2}</p>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};
